import React from 'react';
import { motion } from 'framer-motion';
import { Send, Globe, MapPin } from 'lucide-react';
export function ContactCTA() {
  return <section id="contact" className="py-24 md:py-32 relative overflow-hidden" data-id="element-5">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-dark-bg to-dark-surface z-0" data-id="element-6" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-8">
          <h2 className="text-4xl md:text-6xl font-serif text-gold-100 mb-6" data-id="element-9">
            开启尊享之旅
          </h2>
          <p className="text-xl md:text-2xl text-gold-300 font-serif italic mb-10" data-id="element-10">
            Begin Your Journey
          </p>

          <p className="text-gold-100/70 max-w-xl mx-auto mb-16 leading-relaxed" data-id="element-11">
            Discretion and professionalism are our hallmarks. Contact us today
            to arrange your exclusive experience. We are available 24/7 to
            assist with your reservation.
          </p>
        </motion.div>

        {/* Visit Website Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-16" data-id="element-12">
          <a href="https://www.geylang777-2.site" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-gold-400 text-dark-bg px-10 py-5 text-lg font-bold tracking-wide rounded-sm hover:bg-gold-300 transition-all duration-300 shadow-[0_0_20px_rgba(201,169,110,0.3)] hover:shadow-[0_0_30px_rgba(201,169,110,0.5)] transform hover:-translate-y-1" data-id="element-13">
            <Globe className="w-5 h-5" data-id="element-14" />
            <span data-id="element-15">访问官网 · Visit Website</span>
          </a>
        </motion.div>

        {/* Footer Info */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="mt-8 pt-8 border-t border-gold-400/10 flex flex-col md:flex-row items-center justify-between text-gold-800 text-sm" data-id="element-16">
          <div className="flex items-center mb-4 md:mb-0" data-id="element-17">
            <MapPin className="w-4 h-4 mr-2" data-id="element-18" />
            <span data-id="element-19">Singapore · Premium Service</span>
          </div>
          <p data-id="element-20">TTvip © 2015-2025. All Rights Reserved.</p>
        </motion.div>
      </div>
    </section>;
}